import React from 'react';
import { FireLitSite } from './components/FireLitSite';
export function App() {
  return <FireLitSite data-id="element-0" />;
}